"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvePostMailLetterDesignColorValue = exports.parsePostMailLetterDesignColorHex = exports.resolvePostMailLetterDesignColor = exports.PostMailLetterDesignDefaultColor = void 0;
const validation_1 = require("../constants/validation");
exports.PostMailLetterDesignDefaultColor = "#08AC92";
const isUnusableLetterDesignColor = (color) => {
    const normalized = color.trim().toLowerCase();
    return normalized === "#fff" || normalized === "#ffffff";
};
const normalizeHexColor = (color) => {
    const trimmed = color.trim();
    if (!trimmed || isUnusableLetterDesignColor(trimmed)) {
        return null;
    }
    const withHash = trimmed.startsWith("#") ? trimmed : `#${trimmed}`;
    if (!validation_1.hexColorValidationRegex.test(withHash)) {
        return null;
    }
    return withHash;
};
const resolvePostMailLetterDesignColor = (organizationColor) => {
    if (!organizationColor?.trim()) {
        return exports.PostMailLetterDesignDefaultColor;
    }
    return normalizeHexColor(organizationColor) ?? exports.PostMailLetterDesignDefaultColor;
};
exports.resolvePostMailLetterDesignColor = resolvePostMailLetterDesignColor;
const parsePostMailLetterDesignColorHex = (color) => {
    if (!color?.trim()) {
        return null;
    }
    const withHash = color.trim().startsWith("#") ? color.trim() : `#${color.trim()}`;
    if (!validation_1.hexColorValidationRegex.test(withHash)) {
        return null;
    }
    return withHash;
};
exports.parsePostMailLetterDesignColorHex = parsePostMailLetterDesignColorHex;
const resolvePostMailLetterDesignColorValue = (chosenColor, organizationColor) => (0, exports.parsePostMailLetterDesignColorHex)(chosenColor) ?? (0, exports.resolvePostMailLetterDesignColor)(organizationColor);
exports.resolvePostMailLetterDesignColorValue = resolvePostMailLetterDesignColorValue;
